import React, { Component } from 'react';
import DualBallSpinner from '../img/dual-ball-1s-100px.gif'
import { fetchSignedMessage, getMethod, getSessionValue, emailHeader, httpOKsuccess, cssFormInputText, cssFormInput, cssFormInputLabel, cssFormInputButton, redirectReasonHeader, cssError, textField, passwordField, emailRegularExpression, passwordLength, emailAddressLength} from './Library'
import logo from '../img/app-icon-without-background.png';
import ReactDOM from 'react-dom';
import { error } from 'jquery';
import validator from 'validator';

const resetPasswordResponseMessageDivId = "forgotPasswordMessage";

export class ForgotPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            emailAddress: '',
            errorEmailAddress: ''
        }
    }

    async componentDidMount() {
        if (sessionStorage.getItem(emailHeader) != null) {
            this.setState({ emailAddress: sessionStorage.getItem(emailHeader) });
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.type === 'number' ? parseInt(target.value) : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handlePasswordResetRequest = async (e) => {
        e.preventDefault();
        const isValid = this.handleValidation();
        if (isValid) {
            this.setState({ loading: true });

            const resetPasswordResponse = await fetch(process.env.REACT_APP_API_ENDPOINT + 'user/forgotpassword?username=' + this.state.emailAddress);

            var succesful = (resetPasswordResponse.status == httpOKsuccess);
            var messageLabel = document.getElementById(resetPasswordResponseMessageDivId);

            this.setState({ loading: false })
            if (succesful) {
                ReactDOM.render(<label className={cssFormInputLabel}>Password succesfully changed. You can now <a href='resetpassword'>reset your password</a>.</label>, messageLabel)
            } else {
                const failureReason = resetPasswordResponse.headers.get("Password-Issue");
                this.setState({ errorVerifyPassword: failureReason });
            }
        }
    }

    handleValidation() {
        let validated = true;
        const errors = [];

        if (this.state.emailAddress == "") {
            validated = false;
            errors.push("You must enter your email address");
        } else {
            if (emailRegularExpression.test(this.state.emailAddress)) {
                this.state.emailAddressError = "";
            } else {
                validated = false;
                errors.push("Email address is not formatted correctly");
            }
        }

        this.setState({ errorVerifyPassword: errors.map(error => <li>{error}</li>)})

        return validated;
    }

    render() {
        return (
            <><header>
                <ul className="navbar-nav flex-grow">
                    <img className="logo" src={logo} alt="Receipts and Rewards Logo" width="58px" height="58px" /><div> Receipts  and Rewards </div></ul>
            </header>
                <div id="redirectMessage"/>
                <form onSubmit={this.handlePasswordResetRequest} className={cssFormInput}>
                    <label className={cssFormInputLabel}>
                        Email:
                        <input type={textField} className={cssFormInputText} name="emailAddress" value={this.state.emailAddress} onChange={this.handleInputChange} maxLength={emailAddressLength} />
                    </label>{this.state.errorEmailAddress && <p className={cssError}>{this.state.errorEmailAddress}</p>}
                    
                    <input type="submit" className={cssFormInputButton} value="Reset Password" />
                </form>

                {this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : ''}
                <div id={resetPasswordResponseMessageDivId} />
        </>
        );
    }
}